import { createFileRoute } from '@tanstack/react-router'
import ErrorComponent from '@/features/errors/error-component'
import { zodValidator } from '@tanstack/zod-adapter'
import Index from '@/features/scenic/scenic-spots/pages'
import { searchQueryOptions } from '@/features/scenic/scenic-spots/query-options'
import { SearchSchema } from '@/features/scenic/scenic-spots/schemas/search'

export const Route = createFileRoute('/_authenticated/(scenic)/scenic-spots/')({
  component: Index,
  validateSearch: zodValidator(SearchSchema),
  loaderDeps: ({ search }) => search,
  loader: async ({ context, deps }) => {
    const { queryClient } = context
    await queryClient.ensureQueryData(
      searchQueryOptions({ key: 'scenic-spots', search: deps })
    )
  },
  errorComponent: ({ error }) => {
    return <ErrorComponent error={error} />
  },
})
